<template>
    <div>

        <v-tooltip top color="primary" open-delay="250">
            <template v-slot:activator="{ on }">
                <v-fade-transition>

                    <v-icon v-if="type==='icon'"
                            v-on="on"
                            :class="active ? 'icon-animated' : 'icon'"
                            @click.stop="helpClicked">
                        mdi-help-circle
                    </v-icon>

                </v-fade-transition>
            </template>
            Click here to review documentation
        </v-tooltip>

        <v-tooltip top color="primary" open-delay="250" :disabled="noText">
            <template v-slot:activator="{ on }">
                <v-fade-transition>
                    <v-btn v-if="type==='text'"
                           text
                           v-on="on"
                           :icon="noText"
                           @click.stop="helpClicked"
                           :color="color">
                        <v-icon :left="!noText"
                                size="24"
                                :class="active ? 'icon-animated' : 'icon'">
                            mdi-help-circle
                        </v-icon>
                        <span v-if="!noText">HELP</span>
                    </v-btn>
                </v-fade-transition>
            </template>
            Click here to review documentation
        </v-tooltip>

        <v-fade-transition>
            <v-btn v-if="type==='button'" :color="color" @click.stop="helpClicked">
                <v-icon :class="active ? 'icon-animated' : 'icon'" left>mdi-help-circle</v-icon>
                <span>HELP</span>
            </v-btn>
        </v-fade-transition>

        <help v-if="helpDialogModel"
              v-model="helpDialogModel"
              :identifier="help"
        ></help>
    </div>
</template>

<script>

export default {

    name: "HelpButton",

    components: {
        Help: () => import('../../modules/Help/components/index.vue')
    },

    props: {
        help: {
            required: true,
            type: String,
        },
        type: {
            required: false,
            type: String,
            validator: (value) => {
                return ['icon', 'text', 'button'].includes(value)
            },
            default: 'icon'
        },
        color: {
            required: false,
            type: String,
            default: 'grey lighten-2'
        },
        active: {
            required: false,
            type: Boolean,
            default: true,
        }
    },

    computed: {
        noText() {
            return this.type === 'icon';
        }
    },

    data() {
        return {
            helpDialogModel: false,
        }
    },

    methods: {
        helpClicked() {
            this.helpDialogModel = true;
        },
    }
}
</script>

<style scoped>

.icon {
    margin: 5px !important;
}

.icon-animated {
    background-color: rgba(255, 255, 255, 0);
    margin: 5px !important;
    border-radius: 50%;
    box-shadow: 0 0 0px 0px #2097F3;
    animation: glow 0.5s linear 8 alternate;
}

@keyframes glow {
    to {
        box-shadow: 0 0 5px 5px #2097F3;
    }
}
</style>